/** @jsx jsxPragma */
import React from 'react';
import PropTypes from 'prop-types';
import { css, jsx } from '@emotion/core';

import CybsTextField from '@cybs-ui/components/lib/textfield';

// @ts-ignore
const jsxPragma = jsx;
/**
 * @summary the preceding line is a hack until Babel issue #9095 goes through
 * {@link https://github.com/babel/babel/pull/9095}
 * @author asibilia
 */

class Input extends React.Component {
  static displayName = 'Input';

  handleChange = e => {
    const { cell, rowIdx, colIdx, onCellChange } = this.props;
    onCellChange(e.target.value, cell, rowIdx, colIdx, e);
  };

  render() {
    const {
      characterCountLimit,
      dataTest,
      colIdx,
      rowIdx,
      helpText,
      errorText,
      label,
      rules,
      placeholder,
      disabled,
      width,
      value,
      tableId,
      ...rest
    } = this.props;

    const isRequired = rules && rules.includes('required');
    return (
      <CybsTextField
        id={`${tableId}-text-${rowIdx}-${colIdx}`}
        css={
          width
            ? css`
                margin-top: 0px !important;
                min-width: ${width}% !important;
              `
            : ''
        }
        name={`${tableId}-text-${rowIdx}-${colIdx}`}
        key={`text-key-${rowIdx}-${colIdx}`}
        dataTest={dataTest}
        value={value || ''}
        i18n={{
          label,
          helpText,
          errorText,
          placeholder
        }}
        label={isRequired ? `${label} *` : label}
        multiline={!!characterCountLimit}
        characterCountLimit={characterCountLimit}
        disabled={disabled}
        onChange={this.handleChange}
        onBlur={this.handleChange}
        {...rest}
      />
    );
  }
}

Input.defaultProps = {
  characterCountLimit: null,
  disabled: false,
  errorText: null,
  label: '',
  isLoneField: false,
  placeholder: '',
  rules: [],
  value: ''
};

Input.propTypes = {
  characterCountLimit: PropTypes.bool,
  colIdx: PropTypes.string,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  rowIdx: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  rules: PropTypes.array,
  stateName: PropTypes.string,
  tableId: PropTypes.string.isRequired,
  width: PropTypes.number,
  value: PropTypes.string
};

export default Input;
